// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesHeader_root__2y-lq","closeIcon":"MessagesHeader_closeIcon__3z0sZ","tabs":"MessagesHeader_tabs__9O20G"};